module.exports = __webpack_public_path__ + "img/education.545f02db.jpg";